// extracted by mini-css-extract-plugin
export default {"createEventModal":"OGJivlXkR_9bTAIcLNWd"};